<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="30%"
    title="客户额度调整"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <el-form ref="form" :model="form" :rules="rules" label-width="122px">
        <el-form-item label="客户名称">
          <el-input placeholder="-" :value="currentRow.businessName ||'-' " :size="formSize" disabled />
        </el-form-item>
        <el-form-item label="当前授信额度">
          <el-input placeholder="-" :value="currentRow.creditQuota | toFenThousandsAndFloat" :size="formSize" disabled />
          <div class="accounts_amount_unit">{{ amountUnit(form.nowCreditQuota) }}</div>
        </el-form-item>

        <el-form-item label="授信额度调整至" prop="creditQuota">
          <el-input
            placeholder="请输入"
            style="width: 250px; margin-right: 8px;"
            maxlength="12"
            clearable
            v-model="form.creditQuota"
            v-number-only:2="form.creditQuota"
            :size="formSize"
          />
          <div class="accounts_amount_unit">{{ amountUnit(form.creditQuota) }}</div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize">取消</el-button>
      <el-button type="primary" :size="formSize" :loading="submitLoading" @click="submit()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import NP from 'number-precision';
import { setAdjustQuota } from '@/api/baibu-bill';
import { regFenToYuan, regYuanToFen, getAmountUnit } from '@/utils/number';

const defaultForm = {
  creditQuota: '', // 调整后的授信额度(分)
  nowCreditQuota: '', // 当前授信额度
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error('请输入'));
      } else if (Number(value) <= 0) {
        callback(new Error('请输入大于0的数字'));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      form: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        creditQuota: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: validateAmount, trigger: 'blur' }],
      },
    };
  },
  computed: {
    // 金额单位
    amountUnit() {
      // 这里可以根据参数来返回不同的值
      return (val) => getAmountUnit(val, 3);
    },
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.submitLoading = false;
      this.$refs.form.resetFields();
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(async () => {
        this.form = JSON.parse(JSON.stringify(defaultForm));
        this.form.nowCreditQuota = regFenToYuan(this.currentRow.creditQuota);
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const params = {
              creditQuota: regYuanToFen(this.form.creditQuota), // 元转分
              customerNo: this.currentRow.customerNo,
            };
            this.submitLoading = true;
            await setAdjustQuota(params);
            this.$message.success('调额成功！！');
            this.submitLoading = false;
            this.handleClose();
            this.$emit('success');
          } catch (error) {
            console.log(error);
            this.submitLoading = false;
          }
        }
      });
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
  }
  .content {
    margin-right: 0;
  }
  .el-input.is-disabled .el-input__inner {
    color: #4D4F51;
  }
}

.jr_flex_amount {
  display: flex;
  align-items: center;
  .jr_flex_amount_unit {
    margin-left: 10px;
  }

}
.accounts_amount_unit {
  font-size: 12px;
  margin: 0px;
  padding: 0px;
  color: #64686d;
  line-height: 1;
  margin-top: 4px;
  padding-left: 15px;
}
</style>
